import * as types from './mutation-types'
import { services } from './api'

export const fetchProduct = ({ commit }) => {
  // API request
  return services.products.getAll()
  .then((response) => {
    console.log(response)
    commit(types.FETCH_PRODUCT, response.data)
  })
  .catch((error) => {
    console.error(error)
  })
}
export const fetchSettings = ({ commit }) => {
  console.log('datadata')
  this.$axios
    .get('settings', {
      headers: { Authorization: 'Bearer ' + localStorage.token }
    })
    .then((response) => response.data)
    .then((data) => {
      console.log('datadata')
      console.log(data.data)
      commit('setSettings', data.data)
    })
    .catch(function (error) {
      console.log(error)
    })
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js